import Vue from 'vue';
import config from '../../config/index';

export default {
    // 获取界面化通道数据（可查询）
    getChanelList(params) {
        return Vue.axios.get(`${config.base_url}/roses-platform/srsInterface/getChanelList`, { params });
    },
    // 关闭通道
    closeChanel(params) {
        return Vue.axios.get(`${config.base_url}/roses-platform/srsInterface/closeChanel`, { params });
    },
    // 关闭通道-所有
    closeAllChanel(params) {
        return Vue.axios.get(`${config.base_url}/roses-platform/srsInterface/closeAllChanel`, { params });
    },
}
